import { useEffect, useState } from 'react';
import styles from './style.module.css';

const ACKNOWLEDGED_KEY = 'mof.siteMessage.acknowledged';

function wasAcknowledged() {
    try {
        return localStorage.getItem(ACKNOWLEDGED_KEY) === 'true';
    } catch {
        return false;
    }
}

export default function Message() {
    const [text, setText] = useState('');
    const [isOpen, setIsOpen] = useState(() => !wasAcknowledged());

    useEffect(() => {
        const controller = new AbortController();
        fetch('/api/site-message/', { signal: controller.signal, cache: 'no-store' })
            .then(response => {
                if (!response.ok) throw new Error('Failed to load site message');
                return response.json();
            })
            .then(message => {
                if (message.enabled && typeof message.text === 'string') {
                    setText(message.text);
                }
            })
            .catch(() => {});
        return () => controller.abort();
    }, []);

    const acknowledge = () => {
        try {
            localStorage.setItem(ACKNOWLEDGED_KEY, 'true');
        } catch {
            // Closing still works when browser storage is unavailable.
        }
        setIsOpen(false);
    };

    if (!text.trim()) return null;

    if (!isOpen) {
        return (
            <button
                type="button"
                className={styles.trigger}
                aria-label="Информация о работе сайта"
                aria-haspopup="dialog"
                onClick={() => setIsOpen(true)}
            >
                <span aria-hidden="true">!</span>
            </button>
        );
    }

    return (
        <div className={styles.position}>
            <section className={styles.message} role="dialog" aria-labelledby="site-message-title" aria-describedby="site-message-text">
                <h2 id="site-message-title">Информация о работе сайта</h2>
                <p id="site-message-text">{text}</p>
                <button type="button" onClick={acknowledge}>Понятно</button>
            </section>
        </div>
    );
}
